export default __webpack_public_path__ + "static/media/Story.4ff0b6ae.jpg";